var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceOnActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 30,
    rx: 4.5,
    fill: "white",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95 15.31H13.56V16.17H9.95V15.31ZM10.05 19H9.05V12H13.99V12.87H10.05V19ZM18.5795 19.08C18.0462 19.08 17.5495 18.99 17.0895 18.81C16.6362 18.63 16.2429 18.38 15.9095 18.06C15.5762 17.7333 15.3162 17.3533 15.1295 16.92C14.9429 16.4867 14.8495 16.0133 14.8495 15.5C14.8495 14.9867 14.9429 14.5133 15.1295 14.08C15.3162 13.6467 15.5762 13.27 15.9095 12.95C16.2429 12.6233 16.6362 12.37 17.0895 12.19C17.5429 12.01 18.0395 11.92 18.5795 11.92C19.1129 11.92 19.6029 12.01 20.0495 12.19C20.5029 12.3633 20.8962 12.6133 21.2295 12.94C21.5695 13.26 21.8295 13.6367 22.0095 14.07C22.1962 14.5033 22.2895 14.98 22.2895 15.5C22.2895 16.02 22.1962 16.4967 22.0095 16.93C21.8295 17.3633 21.5695 17.7433 21.2295 18.07C20.8962 18.39 20.5029 18.64 20.0495 18.82C19.6029 18.9933 19.1129 19.08 18.5795 19.08ZM18.5795 18.19C18.9662 18.19 19.3229 18.1233 19.6495 17.99C19.9829 17.8567 20.2695 17.67 20.5095 17.43C20.7562 17.1833 20.9462 16.8967 21.0795 16.57C21.2195 16.2433 21.2895 15.8867 21.2895 15.5C21.2895 15.1133 21.2195 14.7567 21.0795 14.43C20.9462 14.1033 20.7562 13.82 20.5095 13.58C20.2695 13.3333 19.9829 13.1433 19.6495 13.01C19.3229 12.8767 18.9662 12.81 18.5795 12.81C18.1862 12.81 17.8229 12.8767 17.4895 13.01C17.1629 13.1433 16.8762 13.3333 16.6295 13.58C16.3829 13.82 16.1895 14.1033 16.0495 14.43C15.9162 14.7567 15.8495 15.1133 15.8495 15.5C15.8495 15.8867 15.9162 16.2433 16.0495 16.57C16.1895 16.8967 16.3829 17.1833 16.6295 17.43C16.8762 17.67 17.1629 17.8567 17.4895 17.99C17.8229 18.1233 18.1862 18.19 18.5795 18.19Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceOnActive);
export default __webpack_public_path__ + "static/media/faceOnActive.d5af5591590027fea4196efdd9910799.svg";
export { ForwardRef as ReactComponent };